import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface InvoiceDialogProps {
  open: boolean;
  onClose: () => void;
  transaction: any;
}

const InvoiceDialog: React.FC<InvoiceDialogProps> = ({
  open,
  onClose,
  transaction,
}) => {
  if (!transaction) return null;

  const items = [
    { name: "Logo", quantity: 2, price: 450 },
    { name: "Banner (2x5m)", quantity: 1, price: 345 },
    { name: "Poster (1x2m)", quantity: 3, price: 65 },
  ];

  const total = items.reduce((acc, item) => acc + item.price * item.quantity, 0);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="body"
      PaperProps={{
        sx: {
          background: "transparent",
          boxShadow: "none",
          overflow: "visible",
        },
      }}
    >
      {/* Close Button (Outside Top-Right Corner) */}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: -35,
          right: -35,
          color: "white",
          // boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
          // "&:hover": { backgroundColor: "#f5f5f5" },
        }}
      >
        <CloseIcon />
      </IconButton>

      {/* Invoice Card */}
      <DialogContent
        sx={{
          width: 460,
          height: 620,
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
          p: 4,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Typography className="mb-3 fs-8">YOUR<br></br> LOGO</Typography>
        {/* Invoice Header */}
        <Typography
          variant="h6"
          sx={{
            position: "absolute",
            top: 20,
            right: 24,
            fontWeight: 600,
            color: "#666",
          }}
        >
          No. 000001
        </Typography>

        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{ mb: 1, color: "#000" }}
        >
          INVOICE
        </Typography>
        <Typography sx={{ color: "gray", mb: 3 }}>Date: 02 June, 2030</Typography>

        {/* Billing Info */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Box>
            <Typography fontWeight="bold">Billed for:</Typography>
            <Typography>{transaction.CustomerName}</Typography>
            <Typography>123 Anywhere St, Any City</Typography>
            <Typography>hello@realgreatsite.com</Typography>
          </Box>
          <Box>
            <Typography fontWeight="bold">From:</Typography>
            <Typography>Olivia Wilson</Typography>
            <Typography>123 Anywhere St, Any City</Typography>
            <Typography>hello@realgreatsite.com</Typography>
          </Box>
        </Box>

        {/* Items Table */}
        <Table size="small" sx={{ mb: 1 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Item</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Qty</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Price</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, i) => (
              <TableRow key={i}>
                <TableCell>{item.name}</TableCell>
                <TableCell>{item.quantity}</TableCell>
                <TableCell>${item.price}</TableCell>
                <TableCell>${item.price * item.quantity}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={3} align="right" sx={{ fontWeight: "bold" }}>
                Total
              </TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>${total}</TableCell>
            </TableRow>
          </TableBody>
        </Table>

        {/* Payment Info */}
        <Box>
          <Typography>
            <strong>Payment method:</strong> Cash
          </Typography>
          <Typography>
            <strong>Note:</strong> Thank you for choosing us!
          </Typography>
        </Box>

        {/* 🎨 White & Gray Wavy Background Inside Card */}
        <Box
          component="svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 400 200"
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "190px", // your desired height
          }}
        >
          {/* White top wave */}
          {/* <path
    d="M0,80 Q150,20 400,80 L400,200 L0,200 Z"
    fill="#f4f4f4"
  /> */}
          {/* Full gray background under wave */}
          <path
            d="M0,200 Q200,60 400,200 L400,200 L0,200 Z"
            fill="#bdbdbd"
          />


        </Box>
      </DialogContent>

      {/* Download Button (Outside Below Card) */}
      <Box sx={{ textAlign: "center", mt: 2, mb: 3 }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#1976d2",
            borderRadius: "30px",
            px: 4,
            py: 1,
            textTransform: "none",
            fontWeight: 600,
            boxShadow: "0 3px 8px rgba(0,0,0,0.25)",
            "&:hover": { backgroundColor: "#125ea6" },
          }}
        >
          Download
        </Button>
      </Box>
    </Dialog>
  );
};

export default InvoiceDialog;
